import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography, Button, FormHelperText } from '@mui/material';
import { ChangePasswordDialogProps } from './type';
import { COLORS_ADMIN_PAGE } from '../conf/constants';

const ChangePasswordDialog: React.FC<ChangePasswordDialogProps> = ({
  isChangePasswordOpen,
  setIsChangePasswordOpen,
  passwordData,
  handlePasswordChange,
  handlePasswordSubmit,
  passwordError,
}) => {
  const [errors, setErrors] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const validateForm = () => {
    const newErrors = {
      currentPassword: passwordData.currentPassword.trim() ? '' : 'Current Password is required',
      newPassword: passwordData.newPassword.trim() ? '' : 'New Password is required',
      confirmPassword: passwordData.confirmPassword.trim() ? '' : 'Confirm Password is required',
    };
    return newErrors;
  };

  const isFormValid = () => {
    return (
      passwordData.currentPassword.trim() &&
      passwordData.newPassword.trim() &&
      passwordData.confirmPassword.trim()
    );
  };

  const onSubmit = () => {
    const newErrors = validateForm();
    if (isFormValid()) {
      handlePasswordSubmit();
      setErrors({ currentPassword: '', newPassword: '', confirmPassword: '' }); 
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <Dialog open={isChangePasswordOpen} onClose={() => setIsChangePasswordOpen(false)}>
      <DialogTitle>Change Password</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          Please enter the current password and the new password to update to.
        </Typography>
        <Typography variant="subtitle1" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY, mb: -2 }}>
          Current Password
        </Typography>
        <TextField
          label="Current Password"
          name="currentPassword"
          type="password"
          value={passwordData.currentPassword}
          onChange={handlePasswordChange}
          fullWidth
          margin="normal"
          required
          error={!!errors.currentPassword}
          helperText={errors.currentPassword}
        />
        <Typography variant="subtitle1" sx={{ color: COLORS_ADMIN_PAGE.TEXT_SECONDARY, mb: -2 }}>
          New Password
        </Typography>
        <TextField
          label="New Password"
          name="newPassword"
          type="password"
          value={passwordData.newPassword}
          onChange={handlePasswordChange}
          fullWidth
          margin="normal"
          required
          error={!!errors.newPassword}
          helperText={errors.newPassword}
        />
        <TextField
          label="Confirm Password"
          name="confirmPassword"
          type="password"
          value={passwordData.confirmPassword}
          onChange={handlePasswordChange}
          fullWidth
          margin="normal"
          required
          error={!!errors.confirmPassword}
          helperText={errors.confirmPassword}
        />
        {passwordError && (
          <Typography color="error" sx={{ mt: 1 }}>
            {passwordError}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onSubmit}
          sx={{ color: COLORS_ADMIN_PAGE.PRIMARY }}
          disabled={!isFormValid()}
        >
          OK
        </Button>
        <Button onClick={() => setIsChangePasswordOpen(false)} sx={{ color: COLORS_ADMIN_PAGE.PRIMARY }}>
          CANCEL
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;